import { PATH } from './constants/router'
import React from 'react'

const CenterRegistration = React.lazy(() => import('./page/CenterRegistration/index'))

export const ROUTERS = {
  home: {
    path: PATH.HOME,
    component: CenterRegistration,
  },
}

export default ROUTERS